
<span [ngClass]="'view-type'.concat(fromPdf ? '-pdf' : '')" (click)="showViewTypes = !showViewTypes && !fromPdf">
  {{viewType ? viewType.text : ''}}<i class="fa fa-caret-down" *ngIf="!fromPdf"></i>
  <div id="list-of-view-types" *ngIf="showViewTypes">
    <span *ngFor="let vt of viewTypeList" (click)="onViewTypeSelected(vt)" class="view-type-item"
      [class.selected]="vt.cptCategoryViewType === viewType.cptCategoryViewType">{{vt.text}}
    </span>
  </div>
</span>
